import React from 'react'
import styled from 'styled-components'
import { Breadcrumbs, Placeholder } from '../../../Common'

export const ProductPlaceholder = () => {
  return (
    <>
      <Breadcrumbs />
      <Container>
        <Flex className="container-fluid">
          <ImageFlex className="g-1 mb-4">
            <Placeholder image />
          </ImageFlex>
          <TextContainer>
            <Placeholder text width="55%" className="mb-2" />
            <Placeholder text width="85%" className="mb-2" />
            <Placeholder text width="35%" className="mb-2" />
            <Placeholder text width="20%" className="mb-4" />

            <Placeholder text width="99%" className="mb-2" />
            <Placeholder text width="98%" className="mb-2" />
            <Placeholder text width="95%" className="mb-2" />
            <Placeholder text width="97%" className="mb-2" />

            <Div mobile>
              <Placeholder text width="40%" className="mb-2" />
              <Placeholder text width="35%" className="mb-4" />
            </Div>

            <Div desktop>
              <Placeholder text width="97%" className="mb-2" />
              <Placeholder text width="94%" className="mb-2" />
              <Placeholder text width="98%" className="mb-2" />
              <Placeholder text width="94%" className="mb-4" />

              <Placeholder text width="98%" className="mb-2" />
              <Placeholder text width="95%" className="mb-2" />
              <Placeholder text width="97%" className="mb-2" />
              <Placeholder text width="40%" className="mb-2" />
              <Placeholder text width="35%" className="mb-4" />
            </Div>
          </TextContainer>
        </Flex>
      </Container>
    </>
  )
}

const Container = styled.div.attrs({
  className: 'mx-auto pt-lg-5 mt-lg-3 px-lg-5',
})`
  max-width: 128rem;
`

const ImageFlex = styled.div<{ desktop?: boolean }>`
  max-width: 100vw;
  overflow: hidden;
  display: ${(props) => (props.desktop ? 'none' : 'flex')};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: calc(100% - 46rem - 4rem);
  }
`

const Div = styled.div<{ mobile?: boolean; desktop?: boolean }>`
  height: 100%;

  ${(props) =>
    props.mobile &&
    `
        @media(min-width: ${props.theme.breakpoints.lg.min}) {
            display: none;
        }
    `}

  ${(props) =>
    props.desktop &&
    `
        display: none;

        @media(min-width: ${props.theme.breakpoints.lg.min}) {
            display: block;
        }
    `}
`

const Flex = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    display: flex;
    justify-content: space-between;
  }
`

const TextContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    max-width: 46rem;
    min-width: 46rem;
  }
`
